module.exports = __webpack_public_path__ + "img/k8s.72b367d8.svg";